import { render, staticRenderFns } from "./VisitMngMg.vue?vue&type=template&id=0f413e0a"
import script from "./VisitMngMg.vue?vue&type=script&lang=js"
export * from "./VisitMngMg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports